import styled from 'styled-components'

const SearchForm = styled.form`
  display: flex;
  position: relative;
`

export default SearchForm
